import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const pageLayoutRoot = {
  maxWidth: "774px",
  minWidth: "400px",
  marginLeft: "8px",
  marginRight: "8px",
  "& .MuiFormLabel-root": {
    whiteSpace: "nowrap"
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "#000"
  },
  "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
    paddingTop: 4,
    paddingBottom: 5
  }
};

const useStyles = makeStyles({
  pageLayoutRoot,
  pageLayoutFullWidth: {
    ...pageLayoutRoot,
    maxWidth: "100%",
    width: "100%"
  },
  pageLayoutHeading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
});

const ViewPageLayout = ({ children, header, fullWidth }) => {
  const { pageLayoutRoot, pageLayoutFullWidth, pageLayoutHeading } = useStyles();
  return (
    <div className={fullWidth ? pageLayoutFullWidth : pageLayoutRoot} >
      {header && <Typography className={pageLayoutHeading}>{header}</Typography>}
      {children}
    </div>
  );
};

export default ViewPageLayout;
